import { Col, Flex, Image, Row, Typography } from 'antd';
import moment from 'moment';
import { IAuthorizedBy, IPreparedBy } from '../types/commonInterfaces';
import { useAppSelector } from 'app/hooks';

type Props = {
  authorized_by?: IAuthorizedBy;
  prepared_by?: IPreparedBy;
};

const printTime = moment().format('ll LTS');
const { Text } = Typography;

export const signature_text: React.CSSProperties = {
  fontSize: 12,
  fontFamily: "'Source Sans Pro', sans-serif",
  lineHeight: '1.3em',
};

export const InvoiceFooter = ({ authorized_by, prepared_by }: Props) => {
  const user = useAppSelector((state) => state.user);
  const user_agency_id = user?.user_agency_id || null;

  const isTripBeyond = user_agency_id === 103;

  return (
    <div
      style={{
        position: 'absolute',
        width: 'calc(100% - 25px)',
        padding: '20px 10px',
        bottom: 5,
      }}
    >
      <Row justify='space-between' align='bottom'>
        {/* Authorized By */}
        <Col>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            {authorized_by?.sig_signature && (
              <Image
                preview={false}
                style={{
                  width: 80,
                  height: 20,
                  objectFit: 'cover',
                  marginBottom: 4,
                }}
                src={authorized_by?.sig_signature}
              />
            )}
            <div
              style={{
                width: '100%',
                borderTop: '1px dotted gray',
                margin: '4px 0',
              }}
            />
            <Text style={{ ...signature_text, fontSize: 12 }} strong>
              Authorized By
            </Text>
            <Text style={{ ...signature_text, fontSize: 11 }}>{authorized_by?.sig_name_title}</Text>
            <Text style={{ ...signature_text, fontSize: 10 }}>{authorized_by?.sig_position}</Text>
          </div>
        </Col>

        {/* Print Time */}
        <Col>
          <Text
            style={{
              marginTop: '10px',
              fontSize: '10px',
              fontFamily: 'monospace',
            }}
          >
            <Flex vertical align='center'>
              <span>{printTime}</span>
              <span>
                {isTripBeyond ? 'This invoice is auto generated no need to signature' : null}
              </span>
            </Flex>
          </Text>
        </Col>

        {/* Prepared By */}
        <Col>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {prepared_by?.sig_signature && (
              <Image
                preview={false}
                style={{
                  width: 80,
                  height: 20,
                  objectFit: 'cover',
                  marginBottom: 4,
                }}
                src={prepared_by?.sig_signature}
              />
            )}
            <div
              style={{
                width: '100%',
                borderTop: '1px dotted gray',
                margin: '4px 0',
              }}
            />
            <Text style={{ ...signature_text, fontSize: 12 }} strong>
              Prepared By
            </Text>
            <Text style={{ ...signature_text, fontSize: 11 }}>{prepared_by?.sig_name_title}</Text>
            <Text style={{ ...signature_text, fontSize: 10 }}>{prepared_by?.sig_position}</Text>
            {prepared_by?.sig_phone_no && (
              <Text style={signature_text}>Phone No: {prepared_by.sig_phone_no}</Text>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};
